/**
 * @generated SignedSource<<d8358066e15d58ba3a1d0692465944ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedAboutItemPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_user">;
  readonly " $fragmentType": "PdpRespSharedAboutItemPanel_user";
};
export type PdpRespSharedAboutItemPanel_user$key = {
  readonly " $data"?: PdpRespSharedAboutItemPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedAboutItemPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedAboutItemPanel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "54ea029b0cbfa632f72055bdc685c38d";

export default node;
